import axios from "axios";

export const setHeader = (token: string) => {
  axios.defaults.headers.common["authorization"] = "token " + token;
};
